module.exports = __webpack_public_path__ + "img/00008.2f169efb.webp";